class CorsProxy {
  constructor({ baseUrl = '', secretKey = '' }) {
    this.query = '?t=';
    this.secretKey = secretKey;
    this.baseUrl = baseUrl.replace(/\/$/g, '');
  }

  get baseUrlWithQuery() {
    return `${this.baseUrl}/${this.query}`;
  }

  xorChar(char, index) {
    if (!this.secretKey) throw new Error('Required parameter "secretKey" is missing');
    // eslint-disable-next-line no-bitwise
    return String.fromCharCode(char.charCodeAt(0) ^ this.secretKey[index % this.secretKey.length]
      .charCodeAt(0));
  }

  encodeString(str) {
    return [...str].map(this.xorChar.bind(this)).join('');
  }

  encodeUri(uri) {
    return encodeURIComponent(window.btoa(this.encodeString(uri)));
  }

  decodeUri(uri) {
    return this.encodeString(window.atob(decodeURIComponent(uri)));
  }

  format(url) {
    if (!this.baseUrl || url.startsWith(this.baseUrl)) return url;
    return `${this.baseUrlWithQuery}${this.encodeUri(url)}`;
  }

  parse(url) {
    if (!url.startsWith(this.baseUrl)) return url;
    if (!url.includes(this.query)) return url.replace(`${this.baseUrl}/`, '');
    return this.decodeUri(url.replace(this.baseUrlWithQuery, ''));
  }
}

export default CorsProxy;
